import { useInfiniteQuery } from '@tanstack/react-query'
import {
  listImageLibraryFn,
  ListImageLibraryQueryRootKey,
} from '@web/gen/service/creativefabrica/social/v2'
import type { ListImageLibraryResponse } from '@web/gen/service/creativefabrica/social/v2/service_pb'
import type { Cursor } from '@web/gen/service/creativefabrica/common/v1/types_pb'

const ITEMS_PER_PAGE = 9

type PageParam = Cursor | undefined

export function useImageLibraryInfiniteQuery(options?: {
  enabled?: boolean
  itemsPerPage?: number
}) {
  const itemsPerPage = options?.itemsPerPage ?? ITEMS_PER_PAGE

  return useInfiniteQuery<
    ListImageLibraryResponse,
    Error,
    ListImageLibraryResponse,
    (string | { pagination?: { take?: number; after?: Cursor } })[],
    PageParam
  >({
    queryKey: [ListImageLibraryQueryRootKey, { pagination: { take: itemsPerPage } }, 'infinite'],
    queryFn: ({ pageParam }: { pageParam: PageParam }) => {
      return listImageLibraryFn({
        pagination: {
          take: itemsPerPage,
          after: pageParam,
        },
      })
    },
    enabled: options?.enabled ?? true,
    initialPageParam: undefined as PageParam,
    getNextPageParam: lastPage => {
      const hasMore = lastPage?.response?.hasMore ?? false

      if (!hasMore) {
        return
      }

      // Return the next cursor from the response
      return lastPage?.response?.next
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: 60_000,
  })
}
